const WizardLinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Batch Ref. No.", field: "batchRef" },
    { headerName: "Charge Period", field: "chargePeriod" },
    { headerName: "RA Number", field: "ranumber" },
    { headerName: "Description", field: "desc" },
    { headerName: "Location Mnemonic", field: "locMnemonic" },
    { headerName: "Completed Rentals", field: "completedRentals" },
    { headerName: "Non Charged Rentals", field: "noChargeRentals" },
    { headerName: "Void Rentals", field: "voidRentals" }
];

export default WizardLinesColumns;